<template>
  <div
    v-if="null !== headerBanner"
    class="header-banner"
    :title="headerBanner.title"
  >
    <Component
      :is="null === headerBanner.url ? 'div' : NuxtLink"
      :to="headerBanner.url"
    >
      <picture>
        <source
          :srcset="normalizeStrapiUrl(headerBanner.adaptiveImage.url)"
          media="(max-width: 680px)"
        />
        <img
          class="header-banner__image"
          :src="normalizeStrapiUrl(headerBanner.image.url)"
          :alt="headerBanner.title"
        />
      </picture>
    </Component>
  </div>
</template>

<script setup>
import NuxtLink from "#app/components/nuxt-link";
import { useHeaderStore } from "~/store/headerStore";

const headerStore = useHeaderStore();
const { headerBanner } = headerStore;
</script>
